import { graphql } from "../../../services/wp.api.service";

const query = `
mutation GetMagicLink($email: String!, $redirect: String!) {
	getMagicLink(input: {email: $email, redirect: $redirect}) {
		success
	}
}
`;

export const getMagicLinkMutation = (useMutation, options) => useMutation(
	["getMagicLink"],
	({ email, redirect }) => graphql({
		query,
		variables: {
			email,
			redirect
		}
	}, true),
	{
		...options
	}
);
